/**
 * useSyncI18nLanguage — once `/me` resolves, switch i18next to User.language
 * (the server-persisted choice from the Language picker). Falls back to the
 * Telegram-bootstrap locale chosen in main.tsx.
 */

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useMe } from '../hooks/useMe';
import { normaliseLocale } from './index';

export function useSyncI18nLanguage(): void {
  const { data: me } = useMe();
  const { i18n } = useTranslation();
  useEffect(() => {
    if (!me?.language) return;
    const target = normaliseLocale(me.language);
    if (i18n.language !== target) void i18n.changeLanguage(target);
  }, [me?.language, i18n]);
}
